import { render, staticRenderFns } from "./ModalRejectComment.vue?vue&type=template&id=80c47336"
import script from "./ModalRejectComment.vue?vue&type=script&lang=js"
export * from "./ModalRejectComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports